<template>
    <div class="container-scroller" :style="themeColor" id="login-page">
        <b-container fluid class="full-page-wrapper p-0">
            <div class="content-wrapper d-flex align-items-center p-0 f-height auth">
                <div class="content-wrapper">
                    <b-row class="flex-grow p-0 f-height justify-content-center">
                        <b-col lg="3" md="12" sm="12" class="repeat-image h-100 w-100 position-absolute">
                            <div class="brand-logo text-center">
                            </div>
                        </b-col>
                        <b-col lg="9" md="12" sm="12" class="customer-user-profile bg-white overflow-auto"
                            :style="themeColor">
                            <b-card :style="themeColor">
                                <b-row class=" ps-3">
                                    <b-col class="text-center text-md-start" xl="2" cols="3"><img :src="imageUrl"
                                            height="150px" width="150px" alt="logo"></b-col>
                                    <b-col class="text-center text-md-start mt-2" xl="8" cols="7"><span><strong>
                                                <div>
                                                    <span v-if="companySettingData.name">{{ companySettingData.name }}</span><br
                                                        v-if="companySettingData.address1">
                                                    <span v-if="companySettingData.address1">{{ companySettingData.address1
                                                    }}</span><br v-if="companySettingData.address2">
                                                    <span v-if="companySettingData.address2">{{ companySettingData.address2
                                                    }}</span><br v-if="companySettingData.city">
                                                    <span v-if="companySettingData.city">{{ companySettingData.city }}</span><br
                                                        v-if="companySettingData.state">
                                                    <span v-if="companySettingData.state">{{ companySettingData.state }}</span><br
                                                        v-if="companySettingData.country && companySettingData.country.country_name">
                                                    <span
                                                        v-if="companySettingData.country && companySettingData.country.country_name">{{
                                                            companySettingData.country.country_name }}</span>
                                                </div>
                                            </strong></span></b-col>
                                    <b-col cols="12" md="2">
                                        <div class="d-flex justify-content-between">
                                            <b-dropdown variant="light" toggle-class="d-flex align-items-center gap-2"
                                                menu-class="dropdown-menu flag-dropdown navbar-dropdown">
                                                <template #button-content>
                                                    <div>
                                                        <span :class="selectedLanguage.flagClass"></span>
                                                        <span>{{ selectedLanguage.label }}</span>
                                                    </div>
                                                </template>
                                                <b-dropdown-item v-for="language in languages" :key="language.id"
                                                    @click="changeLanguage(language.id)">
                                                    <i :class="language.flagClass"></i> {{ language.label }}
                                                </b-dropdown-item>
                                            </b-dropdown>
                                        </div>
                                    </b-col>
                                </b-row>
                                <b-col class="text-right me-4">
                                    <span class="auth-link signup-link">{{$translate('already_have_account')}}</span> <router-link
                                    to="/login" class="auth-link text-primary fw-bolder decoration-off">
                                    {{$translate('sign_in')}}
                                </router-link>
                                    <!-- <div class="mt-2">Already Have an account ?<a href="">Sign in</a></div> -->
                                </b-col>
                                <b-card-header v-if="currentStep !== 4">
                                    <strong>{{ $translate('step') }} {{ currentStep }} {{ $translate('of') }} {{ totalStep
                                    }}
                                    </strong>
                                </b-card-header>
                                <b-card-body>
                                    <div v-if="currentStep === 1">
                                        <h4>{{ $translate('create_your_profile') }}</h4>
                                        <p>{{ $translate('shere_company_detail') }}</p>
                                        <createProfile :themeColor="themeColor" :companySettingData="companySettingData" v-model="formData.customer"
                                            @next-clicked="handleNextClicked" />

                                    </div>
                                    <div v-else-if="currentStep === 2">
                                        <h4>{{ $translate('mailing_address') }}</h4>
                                        <p>{{ $translate('company_main_address') }} </p>
                                        <mailAddress :themeColor="themeColor" v-model="formData.customer"
                                            @next-clicked="handleNextClicked" @prev-clicked="handlePrevClicked" />
                                    </div>
                                    <div v-else-if="currentStep === 3">
                                        <h4>{{ $translate('add_users') }}</h4>
                                        <Contacts :themeColor="themeColor" :roles="roles" :submitting="isSubmitting"
                                            @submitForm="submitForm" @prev-clicked="handlePrevClicked" />
                                    </div>
                                    <div v-else-if="currentStep === 4">
                                        <div class="checkemail">
                                            <b-col md="12" class=" mb-2 mt-4 text-center">
                                                <h2>{{ $translate('customer_on_borad_message') }}
                                                </h2>
                                                <b-button class="btn btn-info btn-fw me-2 mt-3" @click="redirectToLogin()"
                                                    type="submit" variant="primary">{{
                                                        $translate('login')
                                                    }}</b-button>
                                            </b-col>

                                        </div>
                                    </div>
                                </b-card-body>
                            </b-card>
                            <!-- <Slider /> -->
                        </b-col>
                    </b-row>
                </div>
            </div>
        </b-container>
    </div>
</template>
<script>
import createProfile from './createProfile'
import mailAddress from './mailAddress'
import Contacts from './Contacts'
import logoImage from '@/assets/images/logo.png'
import popupMixins from '@/mixins/popupMixins'


export default {
    components: {
        createProfile,
        mailAddress,
        Contacts
    },
    name: 'customerUsers',
    mixins: [popupMixins],
    data() {
        return {
            totalStep: 3,
            isSubmitting: false,
            currentStep: 1,
            formData: {
                customer: {
                    type_id: null,
                    customer_name: null,
                    first_name: null,
                    last_name: null,
                    email: null,
                    phone: null,
                    address1: null,
                    address2: null,
                    zip_code: null,
                    agreed_to_terms:false,
                    city: 'Kingston',
                    country_code: 'JM',
                    state_name: null,
                },
                // data: {},
            },
            languages: [
                { id: 'en', label: 'English', flagClass: 'flag-uk' },
                { id: 'es', label: 'Español', flagClass: 'flag-spain' }
            ],
            selectedLanguage: ''
        };
    },
    async created() {
        this.$store.dispatch('company/fetch')
    },
    watch: {
        '$i18n.locale': {
            immediate: true,
            handler(val) {
                this.selectedLanguage = this.languages.find(language => language.id === val);
            }
        }
    },
    computed: {
        roles() {
            return this.$store.state.roles.items
        },
        themeColor() {
            const data = this.$store.state.company.settings || {}
            const colors = {
                'background-color': data.background_color + "!important",
                color: data.text_color + "!important"
            }
            console.log(colors, "colors-------");
            return colors
        },
        companySettingData() {
            const data = this.$store.state.company.settings || {}
            return data
        },
        contacts() {
            return this.$store.state.customers.items
        },
        imageUrl() {
            let imageUrl
            const data = this.$store.state.company.settings || {}
            if (data && data.logo) {
                imageUrl = JSON.parse(data.logo).url
            } else {
                imageUrl = logoImage
            }
            return imageUrl
        },
    },
    methods: {
        changeLanguage(obj) {
            if (this.$i18n.locale !== obj) {
                this.$i18n.locale = obj
                localStorage.setItem('language', obj)
                this.$router.go()
            }
        },
        handleNextClicked() {
            if(this.formData.customer.agreed_to_terms){
                this.currentStep++;
            }else{
                this.doToast(
                    this.$translate('error'),
                    this.$translate('agreed_to_terms'),
                    'danger'
                )
            }
        },
        handlePrevClicked() {
            this.currentStep--;
        },
        redirectToLogin() {
            this.$router.push({ name: 'customerLogin' })
        },
        async submitForm() {
            try {
                if (this.formData.customer.type_id == 2 && this.contacts.length == 0)
                    throw new Error(this.$translate('one_user_required'))
                this.formData.contacts = this.contacts
                this.isSubmitting = true
                await this.$store.dispatch(`customers/createContact`, this.formData).then(() => {
                    this.currentStep = 4
                    this.$store.dispatch('customers/clear')
                    this.$nextTick(() => {
                        this.doToast(
                            this.$translate('created'),
                            this.$translate('activate_customer'),
                            'success'
                        )
                    })
                })
            } catch (error) {
                this.doToast(
                    this.$translate('error'),
                    error.message || error.response.data.error.message,
                    'danger'
                )
            } finally {
                this.isSubmitting = false;
            }
        },
    },
};
</script>
